var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(" Oops! Something went wrong. Please check the URL you are visiting or refresh your page ")])}
var staticRenderFns = []

export { render, staticRenderFns }